import React from 'react'
import styled, { ThemeProvider } from 'styled-components'

const Boton = styled.div`
    border: none;
    color: ${props  => props.theme.color};
    background: transparent;
    transition: 200ms ease-in-out;
    cursor: pointer;
    display: inline-flex;
    padding: 0.25rem 0.5rem;
    font-size: 0.875rem;
    line-height: 1.5;
    text-decoration: underline;
    &:hover{
        border-radius: 0.2rem;
        background: ${props  => props.theme.color};
        color: #fff;
        transition: 200ms ease-in-out;
        text-decoration: none;
    }
`;

const ButtonLink = ({ children, onClick, color, ...rest } ) => {

    const getColor = (color) => {
        switch(color){
            case "secondary": return "#6c757d";
            case "warning": return "#ffc107";
            case "danger": return "#dc3545";
            case "dark": return "#343a40";
            case "info": return "#035096";
            default: return "#28a745";
        }
    };

    return(
        <ThemeProvider theme={{ color: getColor(color) }}>
            <Boton {...rest} onClick={onClick} >
                {children}
            </Boton>
        </ThemeProvider>
    )
};

export default ButtonLink